import React from 'react';
import { Route } from 'react-router-dom';
import RequestSent from './requestSent';

const routes = [
  <Route key="requestSent" path="/request_sent"><RequestSent/></Route>
];

export default routes;
